import { Cell } from 'fixed-data-table-2'
import _ from "underscore"

const ORDER_PREFIX = 'SMD-'

export const TextCell = ({ data, rowIndex, columnKey, fieldName, formatter, ...props }) => {
  let text = !!data[rowIndex] ? data[rowIndex][columnKey] : '-'

  if (typeof text === 'object') {
    text = JSON.stringify(text)
  }

  if ([null, undefined, 'null'].includes(text)) {
    text = '-'
  }

  if (fieldName === 'order_id') {
    text = `${ORDER_PREFIX}${text}`
  }

  if (_.isFunction(formatter)) text = formatter(text)

  return (
    <span title={text.length > 20 ? text : ''} className="orders-table__text-cell" {...props}>
      {text}
    </span>
  )
}

export const HeaderCell = ({ ...props }) => (
  <Cell className="orders-table__header-cell" {...props}>
    {props.children}
  </Cell>
)